import React, { Component } from 'react'
import moment from 'moment';
import FixedView from '../FixedView';
import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation, convertToAmPm, translate } from "../../utils/useful";
import Responsive from '../Responsive';


class SelectAvailableTimeInput extends Component {


    state = {

        time: [{ time: '18:00', price: '200$' }, { time: '18:30', price: '200$' }, { time: '19:00', price: '200$' }, { time: '19:30', price: '200$' }, { time: '18:01', price: '200$' }, { time: '18:31', price: '200$' }, { time: '19:01', price: '200$' }, { time: '19:31', price: '200$' }]
    }

    setTime = (item) => {

        this.props.changeValue(this.props.header?.key, item.time, this.props.extra)

    }



    render() {
        let info = this.props.header?.information

        return (
            <div className='mt-0 w-100 h-100 br-2' >

                <p className='text-semibold '>{translate("List of available times")}</p>
                {this.props.fullData?.date && (
                    <p className='text-semibold mt-2 font-size-12 color-gray-2'>{moment(this.props.fullData?.date).format("dddd, MMMM DD YYYY")}</p>
                )}


                <div className="d-flex flex-wrap mt-3">

                    {(info.items.length == 0 && this.props.editMode) && (
                        [1, 1, 1, 1, 1, 1, 1].map((item, index) => {
                            return (
                                <Responsive width={this.props.width} height={'100%'} media={{ xs: '4', 400: '4', 700: '4', lg: '2', xl: '2' }}>

                                    <div className=" flex-column w-95  p-2 px-3 flexc br-4 mb-2 " style={{ height: 30, border: '1px solid #ccc', }}>
                                        <div className='w-100 br-4' style={{height:10,backgroundColor:'#eee'}}>

                                        </div>
                                    </div>
                                </Responsive>
                            )
                        })
                    )}

                    {(info.items.length == 0 && !this.props.editMode) && (
                        <div>
                            <p className='font-size-13'>{translate("No available time. Please select another date")}</p>
                        </div>
                    )}
                    {info.items.map((item, index) => {
                        let selected = item.start == this.props.data
                        return (
                            <Responsive width={this.props.width} height={'100%'} media={{ xs: '4', 400: '4', 700: '4', lg: '2', xl: '2' }}>

                                <button className="w-95 p-2 br-4 flexcc mb-2 available-time-button " style={{ border: selected ? `1px solid ${(this.props.colors?.primaryColor ?? '#007aff')}` : '1px solid #ccc', backgroundColor: selected ? (this.props.colors?.primaryColor ?? '#007aff') : null, color: selected ? (this.props.colors?.textColor ?? '#fff') : '#345' }} onClick={() => { this.setTime(item.start) }}>
                                    <div className=" flex-column w-100">
                                        <div className="text-center">
                                            <div className="flexcc">
                                                {/* <img width={20} src="/assets/icons/booking/clock.svg" /> */}
                                                <p className="font-size-14 ">{convertToAmPm(item.start)}</p>
                                                {/* <p className="font-size-14">{item.time} - {item.time}</p> */}
                                            </div>
                                            {/* <p className="font-size-12">Morning</p> */}

                                        </div>
                                        {/* <div className="flexc">
                                                                            <img width={20} src="/assets/icons/booking/dollar.svg" />
                                                                            <p className="font-size-14 text-semibold">{item.price}</p>
                                                                        </div> */}
                                    </div>
                                    {/* <div className="br-20 px-2 py-2   flexcc " style={{ height: 24, width: 24, background: this.props.colors?.background }} >
                                        <img width={20} src="/assets/icons/arrow-right-white.svg" />

                                    </div> */}
                                </button>
                            </Responsive>
                        )
                    })}
                </div>


            </div >
        )
    }
}

export default SelectAvailableTimeInput;